import React, {useEffect, useState} from 'react';
import {LineChart, Line, XAxis, YAxis, Tooltip, ReferenceArea, ReferenceLine} from 'recharts';
import {CloseOutlined, CloseSquareOutlined, ConsoleSqlOutlined} from "@ant-design/icons";
import {notification, Select, Spin, Tooltip as AntdTooltip} from "antd";
import requestToAPI from "../../lib/Request";

import {
    MUT_UPD_SETTINGS_WIDGET,
    QUERY_GET_HISTORY,
    QUERY_GET_SETTINGS_WIDGET,
    QUERY_GET_DEVICE_MONITOR,
    QUERY_GET_LEGACY_ATTR_STATUS
} from "../../lib/Query";
import {MSG_REQUEST_ERROR} from "../../lib/Const";
import moment from "moment";
import {add, format, differenceInCalendarDays, differenceInHours} from "date-fns";
import CustomTooltip from "./CustomTooltip";
import {colors} from "./Signals";
import {debounce} from "../Debounce";
import {tagRender} from "./TagRender";
import {subscribe} from "../../lib/RequestWS";
import {DataChange} from "./dialogsStatWidget/DataChange";
import {ShowDialogStatWidget} from "./dialogsStatWidget/ShowDialogStatWidget";


// максимальное значение счетчика обновления графика
const MAX_WS_UPDATE_COUNTER = 10;
const UPDATE_TIMEOUT = 60000; // 1 min
const DEFAULT_TIME_MODE = 72; // 72 часа, 3 дня
const TIME_MODES = [
    {
        id: 1,
        label: "1 час",
        description: "Начиная с минус 1 час от текущего момента"
    },
    {
        id: 3,
        label: "3 часа",
        description: "Начиная с минус 3 часа от текущего момента"
    },
    {
        id: 6,
        label: "6 часов",
        description: "Начиная с минус 6 часов от текущего момента"
    },
    {
        id: 12,
        label: "12 часов",
        description: "Начиная с минус 12 часов от текущего момента"
    },
    {
        id: 24,
        label: "1 сутки",
        description: "Начиная с минус 24 часов от текущего момента"
    },
    {
        id: 72,
        label: "3 суток",
        description: "Начиная с минус 3 суток от текущего момента"
    },
    {
        id: 168,
        label: "1 неделя",
        description: "Начиная с минус 7 суток от текущего момента"
    },
    {
        id: 336,
        label: "2 недели",
        description: "Начиная с минус 14 суток от текущего момента"
    },
    {
        id: 720,
        label: "1 месяц",
        description: "Начиная с минус 30 суток от текущего момента"
    }
]
// разница времени между точками в секундах, которую принимаем за обрыв соединения с прибором
const DEVICE_DOWNTIME = 15

export const StatWidget = ({widgetId, deviceName, deviceId, closeWidget, widget, signals}) => {
    
    const [dataGraphics, setDataGraphics] = useState({"data":[],"live":[]})
    const [ticks, setTicks] = useState([])
    const [domain, setDomain] = useState(['auto', 'auto'])
    const [contextParams] = React.useState({})
    const [optionsSelected, setOptionsSelected] = useState([]);
    const [date, setDate] = useState([])

    const [isFetching, setIsFething] = useState(false)
    const [allData, setAllData] = useState([])

    const [timeMode] = React.useState({ mode: DEFAULT_TIME_MODE })


    const [dialogs, changeDialog] = React.useState({
        data: false,
    });

    const changePage = (value, option) => {
        switch (value) {
            case "data":
                changeDialog({...dialogs, data: option})
                break
            default:
                changeDialog({
                    data: false
                })
        }

    }
    

    // прямой запрос данных
    const refreshData = ()=>{
        console.log("timeout refresh data")

        if (TIME_MODES.some(tm => tm.id === timeMode.mode)){
            const now = new Date()
            let startDate = new Date(now)
            startDate = new Date(startDate.setHours(startDate.getHours()-timeMode.mode))
            setDate([moment(startDate).format('yyyy-MM-DDTHH:mm:ss'), moment(now).format('yyyy-MM-DDTHH:mm:ss')])
        }

        requestToAPI.post(QUERY_GET_DEVICE_MONITOR, {
            id: deviceId,
        }).then((res) => {
            updateData(res.data.record)
        });    
    }
    // устанавливаем таймер в первый раз
    if(!contextParams.updateTimerId) {
        contextParams.updateTimerId = setTimeout(refreshData,UPDATE_TIMEOUT)
    }
    // обновленеи данных, счетчиков и таймера
    const updateData = (new_data) => {
        contextParams.wscounter = 0;
        if(contextParams.updateTimerId) {
            clearTimeout(contextParams.updateTimerId);
            delete contextParams.updateTimerId;
        }
        if(TIME_MODES.some(tm => tm.id === timeMode.mode)) {
            const now = new Date();
            now.setMilliseconds(0);
            const startPeriod = new Date(now);
            startPeriod.setHours(now.getHours() - timeMode.mode);
            setDate([startPeriod.toISOString(), now.toISOString()]);
        }
        contextParams.updateTimerId = setTimeout(refreshData,UPDATE_TIMEOUT)
        setAllData(new_data.monitor);        
    }

    useEffect(() => {
        contextParams.mountFlag = true;
        requestToAPI.post(QUERY_GET_SETTINGS_WIDGET, {
            id: widgetId,
        }).then((res) => {

            let options = res.data.dashboardWidgetByPk.setting.filters
            setOptionsSelected(options)

            let firstDate;
            let secondDate;

            if (res.data.dashboardWidgetByPk.setting.end && res.data.dashboardWidgetByPk.setting.beg) {
                firstDate = res.data.dashboardWidgetByPk.setting.beg
                secondDate = res.data.dashboardWidgetByPk.setting.end
                const diff = moment(secondDate).diff(moment(firstDate)) / (1000 * 60 * 60)
                if (TIME_MODES.some(tm => tm.id === diff)){
                    timeMode.mode = diff
                    const now = new Date()
                    secondDate = new Date(now)
                    firstDate = new Date(now.setHours(now.getHours()-diff))
                }
                else {
                    timeMode.mode = -1
                }
            } else {
                firstDate = moment().subtract(DEFAULT_TIME_MODE, 'hours')
                secondDate = moment()
                timeMode.mode = DEFAULT_TIME_MODE
            }
            setDate([firstDate, secondDate])
            getData([firstDate, secondDate], options)

            setIsFething(true)

        }).catch(error => {
            console.error(error);
            throw error;
        })


    }, [])

    useEffect(() => {
        // Вебсокет отправляющий сигналы об изменении данных
        if (requestToAPI.authToken) {
            subscribe(
                `subscription { 
                    deviceUnitByPk(id: ${deviceId}) { 
                        monitor { 
                            updated
                            key
                            value 
                        }
                        model {
                          metadata
                        }
                    } 
                }`,
                (payload) => {
                    const new_data = payload.data.deviceUnitByPk;
                    /* Правило обновления:
                       - Либо через каждые MAX_WS_UPDATE_COUNTER раз 
                       - Либо по истечении UPDATE_TIMEOT сек
                       - либо первый раз (!contextParams.wscounter===undefined)
                    */
                    if (new_data && (contextParams.wscounter===undefined || contextParams.wscounter>=MAX_WS_UPDATE_COUNTER)) {
                        console.log("counter refresh data",contextParams.wscounter)
                        updateData(new_data);
                    };
                    // счетчик запросов
                    contextParams.wscounter++;
                }
            )
        }
    }, [])

    useEffect(() => {
        if (TIME_MODES.some(tm => tm.id === timeMode.mode) || (date[1] && date[1] > new Date())){
            getData([date[0], date[1]], optionsSelected)
        }
    }, [allData])


    function setFilterSettings(beg, end, filters) {
        requestToAPI.post(MUT_UPD_SETTINGS_WIDGET, {
            id: widgetId,
            beg: beg,
            end: end,
            filters: filters,
            pos: widget.setting.pos
        }).then((res) => {
        }).catch(error => {
            console.error(error);
            throw error;
        })
    }

    function resetDate() {
        timeMode.mode = DEFAULT_TIME_MODE
        setDate([moment().subtract(DEFAULT_TIME_MODE, 'hours'), moment()])
        setFilterSettings('', '', optionsSelected)
        getData([moment().subtract(DEFAULT_TIME_MODE, 'hours'), moment()])
    }

    function applyDataChange(firstDate, secondDate, newMode) {
        timeMode.mode = newMode
        setDate([firstDate, secondDate])
        setFilterSettings(firstDate, secondDate, optionsSelected)
        getData([firstDate, secondDate])
    }

    async function getData(data, options = optionsSelected) {

        if (data[0] === '' || data[1] === '' || options.length === 0) {
            return
        }

        let from = new Date(data[0])
        let to = new Date(data[1])

        let query = [];

        query.push("query($unitId:Int!, $from:timestamptz!, $to:timestamptz!) {")

        options.forEach(item => {
            query.push("_"+item+" : getLegacyAttrStatus(unitId: $unitId, key: \""+item+"\", from: $from, to: $to) {")
            query.push("  interval");
            query.push("  items  { num sd ts val }");
            query.push("  before { num sd ts val }");
            query.push("  after  { num sd ts val }");
            query.push("}")
        });

        query.push("h : getHeartbeatStatus(unitId:$unitId, from:$from, to:$to) {");
        query.push("  ranges { from to } }");
        query.push("}")

        query = query.join("\n");

        await requestToAPI.post(query, {
            unitId: deviceId,
            from: from.toISOString(),
            to: to.toISOString(),
        }).then((result) => {
            let newData = {
                "data": {},
                "live": result.data.h.ranges,
                "from": from,
                "to": to,
            };

            Object.keys(result.data).forEach(item => {
                if(item.startsWith("_")) {
                    newData.data[item.substring(1)] = result.data[item];
                }
            });

            setDataGraphics(newData);
        }).catch((error) => {
            notification.error({
                message: MSG_REQUEST_ERROR,
                description: error.message
            })
        });
    }

    const dateFormatter = date => {
        if (dataGraphics.data.length === 0) {
            return
        }
        return moment(date).format('DD.MM.YY HH:mm'); 
    }

    function handleChange(value) {
        setFilterSettings(date[0], date[1], value)
        setOptionsSelected(value)
        getData([date[0], date[1]], value)

    }

    function formatYAxis(value) {
        if (String(value).length < 6) {
            return value
        }
        return value.toExponential(0)
    }

    function createLiveStatusReference() {
        let ranges = dataGraphics.live;

        if(ranges.length == 0) {
            return null;
        }

        let last = moment(dataGraphics.from).valueOf();

        let r = [];

        r.push(
                <YAxis yAxisId="_live_" hide="true" />
        );

        let index = 0;

        for(let i = 0; i<ranges.length; i++) {

            let x2 = moment(ranges[i].from).valueOf();

            if(last<x2) {
                r.push(<ReferenceArea yAxisId="_live_" ifOverflow="visible" fill="red" x1={last} x2={x2} />);
            }

            last = moment(ranges[i].to).valueOf();
        }

        let to = moment(dataGraphics.to).valueOf();

        if(last<to) {
            r.push(<ReferenceArea yAxisId="_live_" ifOverflow="visible" fill="red" x1={last} x2={to} />);
        }
        
        return r;
    }

    function formatTooltipValue(value) {
        return value.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
    }

    function tooltipCreator(props) {

        if (!(props.active)) {
            return null;
        }

        let ts = moment(props.label);

        const style = {
            padding: 6,
            backgroundColor: "#fff",
            color: 'black',
            border: "1px solid #ccc"
        };

        let r = [];

        r.push(
            <p key="timestamp">{ts.format('DD.MM.yyyy HH:mm.ss')}</p>
        );

        optionsSelected.forEach(item => {

            let optionIndex = optionsSelected.indexOf(item);

            if (!(item in dataGraphics.data)) {
                return;
            }

            let items = dataGraphics.data[item].items;

            for (let i = 0; i < items.length; i++) {

                let itemMoment = moment(items[i].ts);

                if (ts.isSame(itemMoment)) {
                    r.push(
                        <p className="custom-tooltip-p" key={item} >
                             <span style={{ color: colors[optionIndex], fontWeight: 800 }}>{signals[item].label}: </span>
                             <em>{formatTooltipValue(items[i].val)}</em>
                         </p>
                    );
                    break;
                }

                if(ts.isBefore(itemMoment)) {
                    break;
                }
            }
        });

        return <div className="area-chart-tooltip" style={style}>{r}</div>;
    }

    function createLines() {

        let r = [];

        let from = moment(dataGraphics.from).valueOf();
        let to = moment(dataGraphics.to).valueOf();

        // Предел X-координаты последней точки графика, определяющий,
        // когда нужно будет рисовать опорную линию значения.
        const referenceLimit = from*0.25+to*0.75;

        function tsValue(v) {
            return moment(v.ts).valueOf()
        }

        r.push(
            <XAxis
                dataKey={tsValue}
                type="number"
                domain={[from, to]}
                tickFormatter={dateFormatter}
                allowDataOverflow
            />,
        )

        // Object.keys(dataGraphics.data).forEach(item => {
        optionsSelected.forEach(item => {

            let optionIndex = optionsSelected.indexOf(item);

            // if(optionIndex<0) {
            //     return;
            // }

            if(!(item in signals)) {
                return;
            }

            if(!(item in dataGraphics.data)) {
                return;
            }

            let series = dataGraphics.data[item];

            let data = [];

            if(series.before) {
                data = [series.before];
            }

            data = [...data, ...series.items];

            if(series.after) {
                data = [...data, series.after]
            }

            let yAxisLabelStyle = Object.assign(
                {
                    value: signals[item].extendedLabel,
                    fill: 'white',
                    offset: 24,
                    style: {textAnchor: 'middle'},
                },
                optionIndex % 2 ? {
                    angle: 90,
                    position: 'insideRight',
                } : {
                    angle: -90,
                    position: 'insideLeft',
                }
            );

            r.push(
                <YAxis
                    yAxisId={item}
                    tickFormatter={formatYAxis}
                    label={yAxisLabelStyle}
                    width={85}
                    orientation={ optionIndex % 2 ? "right" : "left" }
                />,
                <Line
                    yAxisId={item}
                    dataKey="val"
                    data={data}
                    type="monotone"
                    tooltipItemColor={colors[optionIndex]}
                    stroke={colors[optionIndex]}
                    dot={{ r: 1 }}
                    activeDot={{ r: 3}}
                    isAnimationActive={false}
                    name={signals[item].extendedLabel}
                />
            );

            // Добавление опорной линии для экстраполяции.
            if(!series.after && data.length>0) {
                let y = data[data.length - 1].val;
                let x = tsValue(data[data.length - 1]);
                r.push(
                    <ReferenceLine
                        yAxisId={item}
                        segment={[{ x: x, y: y }, { x: to, y: y }]}
                        stroke={colors[optionIndex]}
                        strokeDasharray="3 3"
                    />
                );
            }
        });

        if(optionsSelected.length > 0) {
            r.push(
                <Tooltip content={tooltipCreator}/>
            );
            // r.push(
            //     <Tooltip content={<CustomTooltip/>}/>
            // );
        }

        return r;
    }

    function createChartLayout() {

        if(!isFetching) {
            return <div className="stat-widget">
                <div draggable="true" className="header-widget">
                    <div/>
                    <div className="main-widget-title title-stat-widget">
                        {`${deviceName}`}
                    </div>
                    <div className="area-widget-close" onClick={() => {
                        closeWidget(widgetId)
                    }}>
                        <CloseOutlined className="widget-close"/>
                    </div>
                </div>
                <div>
                    <Spin className="fetching-stat"/>
                </div>
            </div>
        }

        return <div className="stat-widget">
            <div draggable="true" className="header-widget">
                <div />
                <div className="main-widget-title title-stat-widget">
                    {`График временных рядов: ${deviceName}`}
                </div>
                <div className="area-widget-close" onClick={() => {
                    closeWidget(widgetId)
                }}>
                    <CloseOutlined className="widget-close" />
                </div>
            </div>

            <LineChart
                data={dataGraphics.data}
                width={925} height={225}
            >
                {createLines()}
                {createLiveStatusReference()}
            </LineChart>
            <div className="wrapper">
                <div />
                <Select className='select-signals'
                    mode="multiple"
                    style={{ width: 450 }}
                    defaultValue={optionsSelected.map((obj) => {
                        return obj
                    })}
                    size="small"
                    placeholder="Выберите сигналы"
                    tagRender={tagRender}
                    optionLabelProp="label"
                    onChange={(value) => debounceHandleChange(value)}
                >
                    {Object.keys(signals).map((item) => {
                        const colorIdx = optionsSelected.indexOf(item);
                        return <Select.Option
                            value={item}
                            label={{
                                label: signals[item].label,
                                fullName: signals[item].fullLabel,
                                color: colorIdx>=0?colors[colorIdx]:'black'
                            }}
                            disabled={
                                optionsSelected.length > 4
                                    ? optionsSelected.includes(item)
                                        ? false
                                        : true
                                    : false
                            }
                            key={item}
                        >
                            {signals[item].fullLabel}
                        </Select.Option>
                    })}
                </Select>
                <div className="box-button">
                    <div className="reset-buttons">
                        <button style={{ fontSize: 14 }} onClick={() => changePage('data', true)}>
                            {
                                TIME_MODES.some(tm => tm.id === timeMode.mode)
                                    ? `Последни[й/е]: ${TIME_MODES.find(tm => tm.id === timeMode.mode).label}`
                                    : `с ${moment(new Date(date[0])).format('DD.MM.yyyy HH:mm')} по ${moment(new Date(date[1])).format('DD.MM.yyyy HH:mm')}`
                            }
                        </button>
                    </div>

                    {timeMode.mode !== DEFAULT_TIME_MODE
                        ? <AntdTooltip placement="top" title="Сброс выбранной даты">
                            <CloseSquareOutlined onClick={() => resetDate()} style={{ fontSize: 22 }} />
                        </AntdTooltip>
                        : null}

                </div>
            </div>
        </div>;
    }

    function createLayout() {
        return <React.Fragment>
            {createChartLayout()}
            {dialogs.data ?
                <ShowDialogStatWidget
                    title={"Выбор интервала"}
                    number={deviceId}
                    widgetName={deviceName}
                    value={"data"}
                    changePage={changePage}
                    component={<DataChange widget={widget} value={"data"}
                        applyDataChange={applyDataChange}
                        changePage={changePage}
                        curTimeMode={timeMode.mode}
                        timeModes={TIME_MODES}
                        date={!TIME_MODES.some(tm => tm.id === timeMode.mode) ? date : null} />} />
                : null}
        </React.Fragment>;
    }

    // const lineType = "stepAfter";
    const lineType = "monotone";

    const debounceHandleChange = debounce(handleChange, 400)

    return createLayout();
}
